import { TrumpfUxConfig } from "./globals";

export const CONFIG_DEFAULT: TrumpfUxConfig = {
    theme: "web",
    assetPath: "./themes/"
};
